import React from 'react';
import useTranslation from '../../../hooks/translation-hook';
import MissionIntroductionPopup from './MissionIntroductionPopup';

export interface FlashMissionsPopupProps {
  onClose?(dontShowAgain?: boolean): void;
  onViewFlashMissions?(dontShowAgain?: boolean): void;
}

const FlashMissionsPopup = (props: FlashMissionsPopupProps) => {
  const t = useTranslation();
  return (
    <MissionIntroductionPopup
      title={t('flash-missions-intro-title')}
      tagline={t('flash-missions-intro-tagline')}
      body={t('flash-missions-intro-body')}
      examples={t('flash-missions-intro-examples')}
      onClose={props.onClose}
    />
  );
};

export default FlashMissionsPopup;
